// src/pages/Payments.js
import React from 'react';

const Payments = () => (
  <div>
    <h1>Payments</h1>
    <p>Make or manage your payments here.</p>
  </div>
);

export default Payments;
